import React from 'react'
import Wrapper from './style'

const SchInfo = ({icon, text, type}) => {
	return (
		<Wrapper
			className= {
				(() => {
					switch (type) {
						case 'warning':
							return 'warning'
						case 'info':
							return 'info'
						default:
							break;
					}
				})()
			}
		>
			{icon}
			<div className="text">{text}</div>
		</Wrapper>
	)
}

export default SchInfo
